const DecreasedArrow = () => (
    <svg
        width='14'
        height='9'
        viewBox='0 0 14 9'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M7.74487 8.67059C7.38759 9.1098 6.61241 9.1098 6.25513 8.67059L0.157114 1.17432C-0.248967 0.675126 0.179266 1.20825e-06 0.901987 1.14506e-06L13.098 7.88544e-08C13.8207 1.56721e-08 14.249 0.675124 13.8429 1.17432L7.74487 8.67059Z'
            fill='#FF7675'
        />
    </svg>
);

export default DecreasedArrow;
